exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._382c0-R3tbj_-Wbd3WzzpN{width:600px;max-width:90vw}._2jfD5I8kVJB8iT-Iu3B8-2{max-height:400px;overflow-y:auto}._10Jrq0F00FKVmNg5PDJA50{height:40px;display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid #e0e0e0;padding:0 10px}._10Jrq0F00FKVmNg5PDJA50 a._31bQnffy6LOBVQhgSYR-EN{color:inherit;display:inline-block;margin:0 5px}._10Jrq0F00FKVmNg5PDJA50 a._31bQnffy6LOBVQhgSYR-EN:last-child{margin-right:0}.T9pOkUcVPzj54S8FJvQ1L{color:#757575}\n", ""]);

// Exports
exports.locals = {
	"NotificationsPopover": "_382c0-R3tbj_-Wbd3WzzpN",
	"scroll": "_2jfD5I8kVJB8iT-Iu3B8-2",
	"header": "_10Jrq0F00FKVmNg5PDJA50",
	"action": "_31bQnffy6LOBVQhgSYR-EN",
	"light": "T9pOkUcVPzj54S8FJvQ1L"
};